import ApiManager from '../../ApiManager';

export const submitGetRequestToAPI = (path, body, user) => {
  return ApiManager.get(`${path}`, body, user).catch((error) => {});
};

export const submitPostRequestToAPI = (path, body, user) => {
  return ApiManager.post(`${path}`, body, user).catch((error) => {});
};
